import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const FAQS = [{
  q: '¿En qué formato llega?',
  a: 'PDF descargable. Acceso inmediato después del pago. Podés leerlo desde el celular, tablet o computadora. También podés imprimirlo.'
}, {
  q: '¿Sirve si nunca jugué al Truco?',
  a: 'Sí. El Tomo 1 arranca desde cero absoluto. Si nunca tocaste una baraja española en tu vida, vas a terminar el Tomo 1 listo para sentarte en cualquier mesa.'
}, {
  q: '¿Sirve si ya sé jugar?',
  a: 'Sí. Desde el Tomo 2 en adelante el sistema escala en profundidad. Los tomos 3, 4, 5 y 6 están pensados para jugadores que ya conocen las reglas pero quieren el siguiente nivel.'
}, {
  q: '¿Funciona para asado o solo para torneo?',
  a: 'Para los dos. El sistema completo aplica en cualquier contexto: asado familiar, juntada de amigos, club o torneo oficial.'
}, {
  q: '¿Y si juego solo, sin pareja?',
  a: 'El Tomo 4 es específico para parejas pero todo el resto del sistema aplica perfectamente al juego individual (mano a mano o trío).'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-truco-surface" data-id="element-41">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <h2 className="text-3xl font-heading font-bold text-truco-cream mb-10 text-center" data-id="element-43">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-44">
          {FAQS.map((faq, index) => <div key={index} className="border border-truco-gold/20 rounded-lg overflow-hidden bg-truco-dark" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-46">
                <span className="font-heading font-bold text-truco-cream pr-4" data-id="element-47">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-truco-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-50">
                    <div className="px-6 pb-4 text-truco-creamMuted border-t border-truco-gold/10 pt-4" data-id="element-51">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}